import { readPreviewTeam } from '../../../../../../../../service/previewStorage';
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { isEmpty } from 'lodash';
import {
  ratingRangeAbbr,
  simplifiedPosition,
  emptyPlayerToDragPositionName,
} from '../../../../../../../../service/data';
import { POPUPS } from '../../../../../../../../service/constants';
import { showPopupWindow } from '../../../../../../../../redux/actions/Popups';
import { getPlayerInformation } from '../../../../../../../../redux/actions/League';
import {
  pitchPlayerPosition,
  setFormationListFilter,
} from '../../../../../../../../redux/actions/Team';
import {
  getMyCurrentTeam,
  isPremiumUser,
} from '../../../../../../../../redux/selector/User';
import {
  getClickedPositionOnPitch,
  isOpponentUserPremium,
  getCurrentMatchRunning,
  getStrategyCaptain,
  getPlayersForCurrentPosition,
} from '../../../../../../../../redux/selector/Team';
import {
  StyledPlayerCard,
  StyledFitness,
  StyledRatingContainer,
  StyledRatingBadge,
  StyledLabel,
  StyledNameContainer,
  StyledDescription,
  StyledName,
  StyledInfoWrapper,
  StyledPlayerInfoIcon,
  StyledCardBadges,
} from './styled';
import { AppPitchCard } from './appStyled';
import TeamShirt from '../../../../../../../../components/TeamShirt';
import { PitchStatusMarks } from '../../../../../../../../components/MatchMarks';
import { slotRoleStyle } from '../../../../positionRoleStyle';
import {
  playerYellowCards,
  isSuspended,
  isSentOff,
  redCardEntries,
  ownClubId,
} from '../../../../../../../../service/matchEngine';
import { useStrategyPlayerMenu } from '../../../../playerMenuContext';

const badgeColors = {Weakest:'#ff8c82',Weak:'#ffb17b',Average:'#fbd567',Strong:'#83d798','World Class':'#8ce0cf',Legend:'#a6c9ff'};

const PlayerCard = ({
  isAwayTeam,
  opponentTeamName,
  name,
  firstName,
  lastName,
  ratingRange,
  potentialRange,
  formRange,
  playerPos,
  selectedCard,
  _id,
  teamKit,
  onCardClick,
  list = false,
  highlight = false,
  muted = false,
  yellowCards: yellowCardsProp,
  suspension: suspensionProp,
  sentOff: sentOffProp,
  isCaptain: isCaptainProp,
  captainAuto: captainAutoProp,
  ...rest
}) => {
  const { style } = rest;
  const noPlayer = !firstName || !lastName;
  const dispatch = useDispatch();
  const teamData = useSelector(getMyCurrentTeam);
  const isPremium = useSelector(isPremiumUser);
  const isOpponentPremium = useSelector(isOpponentUserPremium);
  const clickedPosition = useSelector(getClickedPositionOnPitch);
  const matchRunning = useSelector(getCurrentMatchRunning);
  const captain = useSelector(getStrategyCaptain);
  const strategyPlayers = useSelector(getPlayersForCurrentPosition);
  const previewTeamData = readPreviewTeam();
  const { open: openPlayerMenu } = useStrategyPlayerMenu();

  const playerFromStore =
    !isAwayTeam && _id
      ? (strategyPlayers || []).find((p) => String(p._id) === String(_id))
      : null;
  const yellows =
    yellowCardsProp != null
      ? yellowCardsProp
      : playerYellowCards(playerFromStore);
  const suspended =
    suspensionProp != null
      ? suspensionProp > 0
      : isSuspended(playerFromStore);
  const userTeamId = teamData?._id || teamData?.id;
  const sentOff =
    sentOffProp != null
      ? sentOffProp
      : isSentOff(_id, matchRunning, userTeamId);
  const captainId = captain?.player?._id;
  const isCaptain =
    isCaptainProp != null
      ? isCaptainProp
      : !!(
          captain !== undefined &&
          captainId &&
          _id &&
          String(captainId) === String(_id)
        );
  const captainAuto =
    captainAutoProp != null ? captainAutoProp : !!(isCaptain && captain?.auto);

  const desktopDisplayName = (fName, lName, emptyName) =>
    fName && lName
      ? `${fName} ${lName[0]}.`
      : `Drag ${emptyPlayerToDragPositionName[playerPos]}`;
  const getPlayerInfo = (e) => {
    if (!list && window.matchMedia('(max-width:1199px)').matches) {
      e.stopPropagation();
      setActivePlayerCard();
      return;
    }
    dispatch(
      showPopupWindow(
        POPUPS.PLAYER_INFO_POPUP_VIEW,
        POPUPS.PLAYER_INFO_POPUP_VIEW,
        true
      )
    );
    dispatch(getPlayerInformation(_id, POPUPS.PLAYER_INFO_POPUP_VIEW));
    e.stopPropagation();
  };

  const getTeamShirt = () => {
    if (noPlayer) {
      return null;
    }
    if (isAwayTeam) {
      return opponentTeamName;
    }
    if (isEmpty(teamData)) {
      return previewTeamData?.name;
    }
    return teamData.name;
  };

  const setActivePlayerCard = () => {
    if (clickedPosition === playerPos) {
      dispatch(pitchPlayerPosition(null));
      dispatch(setFormationListFilter('ALL'));
    } else {
      dispatch(pitchPlayerPosition(playerPos));
    }
  };

  const side = ownClubId(matchRunning, userTeamId);
  const sentOffEntry = sentOff
    ? redCardEntries(matchRunning, side).find(
        (entry) =>
          String(entry?.player?._id || entry?.player?.id) === String(_id)
      )
    : null;
  const statusBadges = !isAwayTeam && !noPlayer && (
    <StyledCardBadges>
      <PitchStatusMarks
        injured={formRange === -1}
        suspended={suspended}
        yellowCards={yellows}
        sentOff={sentOff}
        sentOffSecondYellow={!!sentOffEntry?.second_yellow}
        isCaptain={isCaptain}
        captainAuto={captainAuto}
      />
    </StyledCardBadges>
  );

  const openContextMenu = (event) => {
    if (isAwayTeam || noPlayer || !_id) return;
    event.preventDefault();
    event.stopPropagation();
    const player =
      playerFromStore ||
      {
        _id,
        first_name: firstName,
        last_name: lastName,
        current_position: playerPos,
        fav_position: playerPos,
        form_range: formRange,
      };
    openPlayerMenu({
      x: event.clientX,
      y: event.clientY,
      player,
      slot: playerPos,
      inXi: true,
    });
  };

  if (!list) return <AppPitchCard
    $highlight={highlight || clickedPosition === playerPos} $muted={muted || suspended || sentOff}
    onClick={isAwayTeam ? undefined : () => onCardClick ? onCardClick() : setActivePlayerCard()}
    onContextMenu={openContextMenu}
    title={noPlayer ? desktopDisplayName(firstName, lastName, name) : `${firstName} ${lastName}${suspended ? ' — Suspended' : ''}${sentOff ? ' — Sent off' : ''}${isCaptain ? ' — Captain' : ''}`}
  >
    <div className="kit"><TeamShirt style={style} team={getTeamShirt()} isPremium={(!isAwayTeam && isPremium) || (isAwayTeam && isOpponentPremium)} teamKit={!isAwayTeam && teamKit ? teamKit.pic : null}/></div>
    {!noPlayer && <div className="ratings">
      <span title={`Rating: ${ratingRange || 'Unavailable'}`} style={{color:badgeColors[ratingRange] || '#fff'}}>{ratingRangeAbbr[ratingRange] || '–'}</span>
      <span title={`Potential: ${potentialRange || 'Unavailable'}`} style={{color:badgeColors[potentialRange] || '#fff'}}>{ratingRangeAbbr[potentialRange] || '–'}</span>
    </div>}
    {statusBadges}
    <div className="identity">
      <div className="identity-line">
        <span
          className="slot"
          style={slotRoleStyle(simplifiedPosition[playerPos] || playerPos)}
        >
          {simplifiedPosition[playerPos]}
        </span>
        {!noPlayer && !isAwayTeam ? <button type="button" onClick={getPlayerInfo} aria-label={`View ${firstName} ${lastName}`}>{desktopDisplayName(firstName,lastName,name)}</button> : <span className="player-name">{desktopDisplayName(firstName,lastName,name)}</span>}
      </div>
      {!noPlayer && !isAwayTeam && <StyledFitness form={formRange}/>}
    </div>
  </AppPitchCard>;

  return (
    <StyledPlayerCard
      $list={list}
      $highlight={highlight}
      $muted={muted || suspended || sentOff}
      style={{
        boxShadow:
          !list && clickedPosition === playerPos
            ? '0 0 5px 3px rgb(0 0 0 / 5%)'
            : 'none',
      }}
      onClick={() => {
        if (onCardClick) {
          onCardClick();
          return;
        }
        setActivePlayerCard();
      }}
      awayTeam={isAwayTeam}
      isSelected={String(
        highlight ||
          (playerPos &&
            playerPos.replace(/[()]/g, '').toLowerCase() === selectedCard)
      )}
      type={`${!firstName || !lastName ? 'empty' : 'player'}`}
    >
      <div className="Body">
        <div
          className="position"
          style={slotRoleStyle(simplifiedPosition[playerPos] || playerPos)}
        >
          {simplifiedPosition[playerPos]}
        </div>
        {statusBadges}
        <TeamShirt
          style={style}
          team={getTeamShirt()}
          isPremium={
            (!isAwayTeam && isPremium) || (isOpponentPremium && isAwayTeam)
          }
          teamKit={!isAwayTeam && teamKit ? teamKit.pic : null}
        />
        {!noPlayer && (
          <StyledRatingContainer $list={list}>
            <StyledLabel>{ratingRangeAbbr[ratingRange]}</StyledLabel>
            <StyledRatingBadge $list={list} />
          </StyledRatingContainer>
        )}
        <StyledNameContainer>
          <StyledDescription $list={list}>
            {!noPlayer && !isAwayTeam && !list && (
              <StyledInfoWrapper onClick={getPlayerInfo}>
                <StyledPlayerInfoIcon />
              </StyledInfoWrapper>
            )}

            <StyledName $list={list}>
              {list || isMobile
                ? firstName || name
                : desktopDisplayName(firstName, lastName, name)}
            </StyledName>
          </StyledDescription>
        </StyledNameContainer>
        {!noPlayer && !isAwayTeam && (
          <StyledFitness $list={list} form={formRange} />
        )}
      </div>
    </StyledPlayerCard>
  );
};
PlayerCard.propTypes = {
  isAwayTeam: PropTypes.bool,
  name: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  ratingRange: PropTypes.string,
  formRange: PropTypes.number,
  playerPos: PropTypes.string,
  selectedCard: PropTypes.string,
  _id: PropTypes.string,
  style: PropTypes.object,
};
PlayerCard.defaultProps = {
  isAwayTeam: false,
  name: '',
  firstName: '',
  lastName: '',
  ratingRange: '',
  formRange: null,
  playerPos: '',
  selectedCard: '',
  _id: '',
  style: {},
};
export default PlayerCard;
